import {SmartFormCurrencyDataStore} from "./SmartFormCurrencyDataStore";

(window as any).SmartFormMultipleItemsDataStore=require('./SmartFormMultipleItemsDataStore').SmartFormMultipleItemsDataStore;
(window as any).SmartFormBasicDataStore=require('./SmartFormBasicDataStore').SmartFormBasicDataStore;
(window as any).SmartFormDateDataStore=require('./SmartFormDateDataStore').SmartFormDateDataStore;
(window as any).SmartFormRepeaterDataStore=require('./SmartFormRepeaterDataStore').SmartFormRepeaterDataStore;
(window as any).SmartFormCurrencyDataStore=require('./SmartFormCurrencyDataStore').SmartFormCurrencyDataStore;
declare let require:any;


// WEBPACK FOOTER //
// ./formBuilder/dataStores/SmartFormsDataStoreBootstrap.ts